import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const chipWarningWrapper = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
  marginBottom: vars.space["2xs"],
});
